import "./LoadingCircle.scss";
export default function LoadingCircle() {
  return <span className="app__loadingCircle"></span>;
}
